import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { cn } from '../../../utils/cn';
import { NAV_ITEMS } from './NavLinks';
import { useLanguage } from '../../../contexts/LanguageContext';
import { Button } from '../../ui/Button';

/**
 * Mobile menu overlay component
 *
 * @param {Object} props
 * @param {boolean} props.isOpen - Menu open state
 * @param {Function} props.onClose - Close handler
 * @param {Function} props.onQuoteClick - Quote button click handler
 */
export const MobileMenu = ({ isOpen, onClose, onQuoteClick }) => {
  const location = useLocation();
  const { t } = useLanguage();

  return (
    <div
      className={cn(
        'fixed inset-0 z-50 lg:hidden pointer-events-none'
      )}
    >
      {/* Backdrop */}
      <div
        className={cn(
          'absolute inset-0 bg-gray-900/40 backdrop-blur-sm transition-opacity duration-300',
          isOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'
        )}
        onClick={onClose}
        aria-hidden="true"
      />

      {/* Menu Panel */}
      <nav
        className={cn(
          'absolute right-0 top-0 h-full w-[80%] max-w-sm bg-white shadow-2xl p-8',
          'flex flex-col gap-8 transition-transform duration-500 cubic-bezier(0.16, 1, 0.3, 1) pointer-events-auto',
          isOpen ? 'translate-x-0' : 'translate-x-full'
        )}
        aria-label="Mobile navigasyon"
      >
        <div className="flex flex-col gap-6 mt-12" role="menubar">
          {NAV_ITEMS.map(({ path, labelKey }) => (
            <Link
              key={path}
              to={path}
              className={cn(
                'block text-2xl font-bold tracking-tight transition-colors',
                location.pathname === path
                  ? 'text-primary'
                  : 'text-gray-900 hover:text-primary'
              )}
              onClick={onClose}
              role="menuitem"
              aria-current={location.pathname === path ? 'page' : undefined}
            >
              {t(labelKey)}
            </Link>
          ))}
        </div>

        <div className="mt-auto pb-8">
          <Button
            onClick={() => {
              onQuoteClick();
              onClose();
            }}
            className="w-full h-14 text-lg shadow-lg shadow-secondary/20"
            variant="secondary"
          >
            {t('header.quote')}
          </Button>
        </div>
      </nav>
    </div>
  );
};
